import { RCCallout } from '@reverbdotcom/cadence/components';
import React from 'react';
import I18n from 'i18n-js';
import { WarningCircleIcon } from '@phosphor-icons/react';

export function StatementPaymentNeededBanner() {
  return (
    <RCCallout
      themeType="utility"
      variant="urgent-ultralight"
      icon={<WarningCircleIcon />}
      title={I18n.t('discovery.payStatement.statementPaymentNeededBanner.headline')}
    >
      <p>{I18n.t('discovery.payStatement.statementPaymentNeededBanner.message')}</p>
    </RCCallout>
  );
}

export default StatementPaymentNeededBanner;
